export const STATIC_VIDEO_TYPE = 'File';
export const TEXTUAL_CONTENT_ID = 'feature-demo-content';
export const VIDEO_CONTENT_ID = 'feature-demo-video';
